<template>
    <div class="container-fluid input-group">
        <div class="col-12 py-50">
            <label class="group-label px-25">{{label}}</label>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default{
        props:{
            label:{
                type:String,
                required:true
            }
        }
    }
</script>